import { Component, computed } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'bmt-user-admin',
    templateUrl: './user-admin.component.html',
    styleUrls: ['./user-admin.component.scss'],
    standalone: false
})
export class UserAdminComponent {
  readonly routeParams = toSignal(this.activeRoute.params, {
    initialValue: this.activeRoute.snapshot.params
  });
  readonly page = computed(() => this.routeParams()?.['id'] || 'create');

  constructor(
    private readonly activeRoute: ActivatedRoute,
  ) {
  }


}
